import { Wrapper } from '@styled_components/author/styled.components'
import Layout from '@components/organisms/Layouts/WithoutSidebar'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import BecomeAuthor from '@components/pages/become-author'
// const BecomeAuthor = lazy(() => import('@components/pages/become-author'))
import Head from 'next/head'
import { useTranslation } from 'react-i18next'
import Script from 'next/script'

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'home',
        'author',
        'aboutAuthor',
        'courses',
        'footer',
        'home',
        'createCourse',
        'becomeAuthorDetailsModal',
        'signUp',
        'wishlistDropdown',
        'landingPage',
        'stickyCoursePageBlock',
        'advantageous',
        'authentication',
      ])),
    },
  }
}

const Author = () => {
  const { t, i18n } = useTranslation()

  return (
    <>
      <Head>
        <title>{t('becomeAuthorOnEdugram', { ns: 'aboutAuthor' })}</title>
        <meta property="og:image" content="/static/images/becomeAuthor.png" />
        <meta property="og:image:width" content="480" />
        <meta property="og:image:height" content="360" />
        <meta
          property="og:title"
          content={t('becomeAuthorOnEdugram', { ns: 'aboutAuthor' })}
        />
        <meta
          property="og:description"
          content={t('shareAndMonetize', { ns: 'aboutAuthor' })}
        />
        <meta
          name="description"
          content={t('shareAndMonetize', { ns: 'aboutAuthor' })}
        />
        <meta
          name="twitter:title"
          content={t('becomeAuthorOnEdugram', { ns: 'aboutAuthor' })}
        />
        <meta
          name="twitter:description"
          content={t('twitterDescription', { ns: 'aboutAuthor' })}
        />
        <meta name="twitter:image" content="/static/images/becomeAuthor.png" />
      </Head>
      <Layout>
        <Wrapper>
          <BecomeAuthor />
        </Wrapper>
      </Layout>
      <Script id="tidio-lang">
        {`
    document.tidioChatLang = '${i18n.language}';
  `}
      </Script>
      <Script
        src="//code.tidio.co/i7mp49mi5ywbn8ozh4pipqwpjumsive6.js"
        strategy="lazyOnload"
      />
    </>
  )
}

export default Author
